//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import axios from 'axios';
//------------------------------------------------------------------------------
// Helpers & Constants ---------------------------------------------------------
import { ResponseStatusCode, HeadersKey } from '@helpers/constants/api';
import { AuthorizationStorageKey } from '@helpers/constants/localStorage';
import { getValue } from '@helpers/localStorage';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { deauth } from '@helpers/auth';
//------------------------------------------------------------------------------
// Methods ---------------------------------------------------------------------
const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});
client.defaults.headers.common[HeadersKey.StoreId] =
  import.meta.env.VITE_STORE_ID;
client.interceptors.request.use(
  (request) => {
    const authorizationToken = getValue(AuthorizationStorageKey);

    if (authorizationToken) {
      request.headers.set(HeadersKey.Authorization.request, authorizationToken);
    }
    return request;
  },
  (error) => Promise.reject(error)
);

client.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    const { response: { status } = {} } = error || {};
    if (
      status === ResponseStatusCode.Unauthorized ||
      status === ResponseStatusCode.Forbidden
    )
      return deauth();
    return Promise.reject(error);
  }
);

export default client;
